import Label from "../ui-components/Label";
import { useState } from "react";
import { PencilIcon, TrashIcon } from "@heroicons/react/24/solid";
import Button from "../ui-components/Button";
import SpreadsheetOutputRangeModal from "./SpreadsheetOutputRangeModal";

const ServiceConfiguratorBlockSpreadsheetOutputRanges = ({
  spreadsheetConfigurationObject,
  updateSpreadsheetConfiguration,
  editable=true,
})=>{
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedOutputRangeIndex, setSelectedOutputRangeIndex] = useState(null);

  return (
    <div className="flex w-full flex-col mb-4">
      <Label>output ranges</Label>
      <div className="mb-2" />
      {spreadsheetConfigurationObject.output_ranges.map(({key, sheet, range, type}, index) => {
        return (
          <div
            key={index}
            className={`flex w-full justify-between items-center rounded border border-gray mt-2 mb-2 p-1.5`}
          >
            <div className="flex items-center">
              <div>
                <p>{key} - {sheet} ! {range} ({type})</p>
              </div>
            </div>
            <div className="flex ">
              <div
                onClick={() => {
                  if (editable) {
                    setModalOpen(true)
                    setSelectedOutputRangeIndex(index)
                  }
                }}
                className={`w-7 h-7 mr-2 ${editable ? 'cursor-pointer' : 'cursor-not-allowed'} text-gray-400`}
              >
                <PencilIcon/>
              </div>
              <div
                onClick={() => {
                  if (editable)
                    updateSpreadsheetConfiguration({
                      ...spreadsheetConfigurationObject,
                      output_ranges: spreadsheetConfigurationObject.output_ranges.filter((item, i) => i !== index)
                    })
                }}
                className={`w-7 h-7 ${editable ? 'cursor-pointer' : 'cursor-not-allowed'} text-red-600`}
              >
                <TrashIcon/>
              </div>
            </div>
          </div>
        );
      })
      }
      {editable && <Button
        onClick={() => {
          setModalOpen(true)
          updateSpreadsheetConfiguration({
            ...spreadsheetConfigurationObject,
            output_ranges: spreadsheetConfigurationObject.output_ranges.concat([{
              key: "",
              sheet: "",
              range: "",
              type: "number"
            }])
          })
          setSelectedOutputRangeIndex(spreadsheetConfigurationObject.output_ranges.length)
        }}
        className="w-full"
      >
        Add output range
      </Button>}
      {modalOpen && (
        <SpreadsheetOutputRangeModal
          spreadsheetConfigurationObject={spreadsheetConfigurationObject}
          updateSpreadsheetConfiguration={updateSpreadsheetConfiguration}
          selectedOutputRangeIndex={selectedOutputRangeIndex}
          onExit={() => {
            setModalOpen(false);
          }}
        />
      )}
    </div>)
}

export default ServiceConfiguratorBlockSpreadsheetOutputRanges;